// extracted by mini-css-extract-plugin
module.exports = {"twitch-embed":"twitchEmbedVideo__twitch-embed___282ng"};